<p>delete-multiple works!</p>
